import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAnalyticsStore } from '../../../stores/analyticsStore';
import { BarChart2, TrendingUp, TrendingDown } from 'lucide-react';

export default function QuickAnalytics() {
  const navigate = useNavigate();
  const { entries, generateInsights } = useAnalyticsStore();
  
  if (entries.length === 0) return null;

  const latestEntry = entries[0];
  const previousEntry = entries[1];

  const getPercentageChange = (current: number, previous: number) => {
    if (!previous) return 0;
    return ((current - previous) / previous) * 100;
  };

  const formatMetric = (value: number) => {
    if (value >= 1000000) {
      return `${(value / 1000000).toFixed(1)}M`;
    }
    if (value >= 1000) {
      return `${(value / 1000).toFixed(1)}K`;
    }
    return value.toString();
  };

  const metrics = [
    {
      label: 'Visualizações',
      value: latestEntry.views,
      previousValue: previousEntry?.views,
      color: 'blue'
    },
    {
      label: 'Engajamento',
      value: latestEntry.engagementRate,
      previousValue: previousEntry?.engagementRate,
      color: 'green',
      isPercentage: true
    }
  ];

  return (
    <div 
      onClick={() => navigate('/dashboard/analises')}
      className="grid grid-cols-1 md:grid-cols-2 gap-4 cursor-pointer hover:opacity-90 transition-opacity"
    >
      {metrics.map((metric) => {
        const change = getPercentageChange(metric.value, metric.previousValue);
        const isPositive = change > 0;

        return (
          <div
            key={metric.label}
            className="p-4 bg-gray-50 rounded-lg border border-gray-100"
          >
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium text-gray-600">
                {metric.label}
              </span>
              {metric.previousValue && (
                <div className={`flex items-center text-sm ${
                  isPositive ? 'text-green-600' : 'text-red-600'
                }`}>
                  {isPositive ? (
                    <TrendingUp className="h-4 w-4 mr-1" />
                  ) : (
                    <TrendingDown className="h-4 w-4 mr-1" />
                  )}
                  {Math.abs(change).toFixed(1)}%
                </div>
              )}
            </div>
            <div className="text-2xl font-bold text-gray-900">
              {metric.isPercentage ? (
                `${metric.value.toFixed(1)}%`
              ) : (
                formatMetric(metric.value)
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}